import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import { base_url } from 'Backend/api';
import { addressListFromApi } from 'utils/addressListFromApi';
import LocationPicker from './LocationPicker';
import NotificationsSidebar from './NotificationsSidebar';
import { listenNotifications } from 'firebase';
import toast from 'react-hot-toast';

const ResponsiveTopNavigation2 = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const [cartCount, setCartCount] = useState(0);
  const [isLocationOpen, setIsLocationOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [activeAddress, setActiveAddress] = useState("");
  const [addresses, setAddresses] = useState([]);
  const [isAddressDropdownOpen, setIsAddressDropdownOpen] = useState(false);


  const menuItems = [
    { id: 'home', label: 'الرئيسية', icon: 'Home', path: '/' },
    { id: 'orders', label: 'طلباتي', icon: 'ShoppingBag', path: '/orders' },
    { id: 'cart', label: 'السلة', icon: 'ShoppingCart', path: '/cart' },
    { id: 'favorites', label: 'المفضلة', icon: 'Heart', path: '/favorites' },
    { id: 'account', label: 'الحساب', icon: 'User', path: '/account' }
  ];

  const handleMenuItemClick = (path) => {
    setIsMobileMenuOpen(false);
    if (path) {
      navigate(path);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const fetchCartCount = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${base_url}/api/cart`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      });

      const data = await response.json();

      if (data.status) {
        setCartCount(data.data.summary.items_count || 0);
      }

    } catch (error) {
      console.error("Cart count error", error);
    }
  };

  useEffect(() => {
    fetchCartCount();
  }, []);

  useEffect(() => {
    const updateCart = () => {
      fetchCartCount();
    };

    window.addEventListener("cartUpdated", updateCart);

    return () => {
      window.removeEventListener("cartUpdated", updateCart);
    };
  }, []);

  const openNotifications = () => {
    setIsNotificationOpen(true);
  };

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${base_url}/api/notifications`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      });

      const data = await response.json();

      if (data.status) {

        const list = data.data.data;

        const unread = list.filter(n => !n.read_at).length;

        setUnreadCount(unread);

      }

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchNotifications();
    }, 10000);

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {

    listenNotifications((payload) => {

      console.log("FCM PAYLOAD", payload);

      const title =
        payload.notification?.title ||
        payload.data?.title ||
        "إشعار جديد";

      const body =
        payload.notification?.body ||
        payload.data?.body ||
        "";

      toast.success(
        <div className="font-[cairo]">
          <strong>{title}</strong>
          <p>{body}</p>
        </div>
      );

      setUnreadCount(prev => prev + 1);

    });

  }, []);


  //   const fetchActiveAddress = async () => {
  //   try {
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(`${base_url}/api/addresses`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "application/json"
  //       }
  //     });

  //     const data = await response.json();

  //     if (data.status) {

  //       const active = data.data.find(addr => addr.is_active);
  //       if (active) {
  //         setActiveAddress(active.description);
  //       } else {
  //         setActiveAddress("لم يتم تحديد موقع بعد");
  //       }
  //     }

  //   } catch (error) {
  //     console.error("Error fetching active address:", error);
  //     setActiveAddress("لم يتم تحديد موقع بعد");
  //   }
  // };
  const fetchAddresses = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${base_url}/api/addresses`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      });

      const data = await response.json();

      if (!data.status) return;

      const list = addressListFromApi(data.data);
      setAddresses(list);

      const active = list.find((addr) => !!addr.is_active);
      setActiveAddress(active?.description?.trim() ? active.description : "");
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchAddresses();
  }, [fetchAddresses, location.pathname]);

  useEffect(() => {
    const onAddressesUpdated = () => {
      fetchAddresses();
    };
    window.addEventListener("addressesUpdated", onAddressesUpdated);
    return () => window.removeEventListener("addressesUpdated", onAddressesUpdated);
  }, [fetchAddresses]);

  const setActiveAddressHandler = async (slug, description) => {
    try {

      const token = localStorage.getItem("token");

      const response = await fetch(`${base_url}/api/addresses/${slug}/set-active`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      });

      const data = await response.json();

      if (data.status) {

        setActiveAddress(description);
        setIsAddressDropdownOpen(false);
        toast.success("تم تغيير العنوان النشط");
        fetchAddresses();

      }

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>

      <nav className="top-navigation" dir='ltr'>
        <div className="top-navigation-logo">
          <div className="top-navigation-logo-icon">
            {/* <Icon name="Utensils" size={24} color="var(--color-primary)" /> */}
            <img src='/assets/images/logo.jpeg' className='rounded-full' />
          </div>
          <span className="hidden md:inline font-[Cairo] text-[16px] font-semibold">
            يسلمو
          </span>
        </div>

        <div className="top-navigation-menu" dir='rtl'>
          {menuItems?.map((item) => (
            <div
              key={item?.id}
              className={`top-navigation-menu-item ${location.pathname === item?.path ? 'active' : ''
                } relative`}
              onClick={() => handleMenuItemClick(item?.path)}
            >
              {item?.label}

              {item?.id === "cart" && cartCount > 0 && (
                <span className="absolute -top-2 -left-2 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                  {cartCount}
                </span>
              )}
            </div>
          ))}
        </div>

        <div className="top-navigation-actions">
          {/* <div
            className="top-navigation-location cursor-pointer relative"
            onClick={() => setIsAddressDropdownOpen(!isAddressDropdownOpen)}
          >
            <Icon name="MapPin" size={16} color="currentColor" />
            <span className='font-[cairo] line-clamp-1'>{activeAddress || "..."}</span>
          </div> */}
          <div
            onClick={() => navigate("/my-addresses")}
            className={`flex items-center justify-between gap-2 px-3 py-1.5 rounded-full cursor-pointer transition-all
    bg-[#FFF4E3]
    border
    ${true ? "border-orange-500" : "border-green-500"}
    w-[198px] md:w-[260px]
  `}
            dir="rtl"
          >
            {/* Icon */}
            {/* <Icon
              name="MapPin"
              size={16}
              className={`${true ? "text-orange-500" : "text-green-500"}`}
            /> */}
            <img className='w-4 h-4' src='/assets/images/mmap.svg' />

            {/* Text */}
            <span className="flex-1 text-center text-[12px] font-medium font-[cairo] truncate">
              {activeAddress || "لم يتم تحديد اى موقع"}
            </span>

            {/* Dropdown icon */}
            {/* <Icon
              name="ChevronDown"
              size={16}
              className={`${true ? "text-orange-500" : "text-green-500"}`}
            /> */}
            <img className='w-5 h-5' src='/assets/images/frr.svg' />
          </div>


          <div
            className="top-navigation-icon-button relative cursor-pointer"
            onClick={openNotifications}
          >
            <Icon name="Bell" size={20} />

            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full font-[cairo]">
                {unreadCount}
              </span>
            )}

          </div>
          <div
            onClick={() => navigate('/account')}
            className="top-navigation-icon-button">
            <Icon name="User" size={20} color="var(--color-foreground)" />
          </div>
        </div>

        {/* Hamburger button - only visible on mobile/tablet */}
        {/* <button

          className="lg:hidden fixed top-3 right-4 z-50 w-10 h-10 rounded-lg bg-card shadow-md flex items-center justify-center cursor-pointer hover:bg-muted transition-all duration-250"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <Icon
            name={isMobileMenuOpen ? 'X' : 'Menu'}
            size={24}
            color="var(--color-foreground)"
          />
        </button> */}
      </nav>
      {/* Bottom Navigation - Mobile Only */}
{/*  */}

      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay">
          <div className="mobile-menu-content">
            <div className="flex items-center justify-between mb-8">
              <div className="top-navigation-logo">
                <div className="top-navigation-logo-icon">
                  <Icon name="Utensils" size={24} color="var(--color-primary)" />
                </div>
                <span className="top-navigation-logo-text">RestaurantWeb</span>
              </div>
            </div>

            <div className="top-navigation-location mb-6">
              <Icon name="MapPin" size={16} color="currentColor" />
              <span>{activeAddress || "جارٍ التحميل..."}</span>
            </div>

            {menuItems?.map((item) => (
              <div
                key={item?.id}
                className={`mobile-menu-item ${location.pathname === item?.path ? 'active' : ''
                  }`}
                onClick={() => handleMenuItemClick(item?.path)}
              >
                <div className="flex items-center gap-3">
                  <Icon name={item?.icon} size={20} color="currentColor" />
                  <span>{item?.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <NotificationsSidebar
        isOpen={isNotificationOpen}
        onClose={() => setIsNotificationOpen(false)}
        setUnreadCount={setUnreadCount}
      />
    </>
  );
};

export default ResponsiveTopNavigation2;